// SPDX-License-Identifier: AGPL-3.0-or-later

export interface MicTestAudioGraph {
	source: MediaStreamAudioSourceNode;
	analyser: AnalyserNode;
	inputGain: GainNode;
	outputGain: GainNode;
	playbackTarget: AudioNode;
}

interface CreateMicTestAudioGraphOptions {
	audioContext: AudioContext;
	stream: MediaStream;
	inputGain: number;
	outputGain: number;
	playbackTarget: AudioNode;
}

export function createMicTestAudioGraph({
	audioContext,
	stream,
	inputGain,
	outputGain,
	playbackTarget,
}: CreateMicTestAudioGraphOptions): MicTestAudioGraph {
	const source = audioContext.createMediaStreamSource(stream);
	const analyser = audioContext.createAnalyser();
	const inputGainNode = audioContext.createGain();
	const outputGainNode = audioContext.createGain();
	analyser.fftSize = 2048;
	inputGainNode.gain.value = inputGain;
	outputGainNode.gain.value = outputGain;
	source.connect(analyser);
	analyser.connect(inputGainNode);
	inputGainNode.connect(outputGainNode);
	outputGainNode.connect(playbackTarget);
	return {
		source,
		analyser,
		inputGain: inputGainNode,
		outputGain: outputGainNode,
		playbackTarget,
	};
}
